import { render, staticRenderFns } from "./DragItemContent.vue?vue&type=template&id=5118e963&scoped=true"
import script from "./DragItemContent.vue?vue&type=script&lang=js"
export * from "./DragItemContent.vue?vue&type=script&lang=js"
import style0 from "./DragItemContent.vue?vue&type=style&index=0&id=5118e963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118e963",
  null
  
)

export default component.exports